import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import { useCallback, useMemo, useState } from 'react';
import { COLUMN_MODE_PANEL_HEIGHT_PERCENT, ROW_MODE_PANEL_WIDTH_PERCENT } from '../../constants/constants';
import { useIsRowLayoutMode } from '../../hooks/useIsRowLayoutMode';
import { useAppSelector } from '../../redux/store';
import { LOBBY_ROOMS_PANEL_BACKGROUND_COLOR } from '../../styles/colors';
import { lightTheme } from '../../styles/materialTheme';
import { CreateGameModal } from './createGameModal/createGameModal';
import { LobbyNextTourneyDisplayContainer } from './lobbyNextTourneyDisplayContainer';
import { LobbyRoomDisplay } from './lobbyRoomDisplay';
const ROOMS_CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  gap: 2px;
  background-color: ${LOBBY_ROOMS_PANEL_BACKGROUND_COLOR};
  border: 1px solid black;
  height: 100%;
  border-radius: 14px;
  overflow: auto;
  overscroll-behavior: auto;
`;
export const LobbyRoomsPanel = () => {
    const [isCreateGameDialogOpen, setIsCreateGameDialogOpen] = useState(false);
    const lobbyRooms = useAppSelector((state) => state.lobby.lobbyRooms);
    const currentRoomId = useAppSelector((state) => state.lobby.currentRoomId);
    const isPanelOpen = useAppSelector((state) => !!state.panels.activePanelType);
    const isRowLayoutMode = useIsRowLayoutMode();
    const onClickOpenCreateGameDialog = useCallback(() => {
        setIsCreateGameDialogOpen(true);
    }, []);
    const onCloseCreateGameDialog = useCallback(() => {
        setIsCreateGameDialogOpen(false);
    }, []);
    const containerCss = useMemo(() => {
        return css(css `
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 5px;
      `, isPanelOpen
            ? isRowLayoutMode
                ? css `
              width: ${100 - ROW_MODE_PANEL_WIDTH_PERCENT}%;
              height: 100%;
            `
                : css `
              width: 100%;
              height: ${100 - COLUMN_MODE_PANEL_HEIGHT_PERCENT}%;
            `
            : css `
            height: 100%;
            width: 100%;
          `);
    }, [isPanelOpen, isRowLayoutMode]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { "data-testid": 'main-content', css: containerCss, children: [_jsx(ThemeProvider, { theme: lightTheme, children: _jsxs("div", { css: ROOMS_CONTAINER_CSS, children: [_jsx(LobbyNextTourneyDisplayContainer, {}), lobbyRooms.map((lobbyRoom, i) => (_jsx(LobbyRoomDisplay, { lobbyRoom: lobbyRoom, currentRoomId: currentRoomId }, i)))] }) }), _jsx("div", { children: _jsx(Button, { "data-testid": 'open-create-game-modal-button', variant: 'outlined', onClick: onClickOpenCreateGameDialog, startIcon: _jsx(AddRoundedIcon, {}), children: "Create Game" }) })] }), isCreateGameDialogOpen && _jsx(CreateGameModal, { onClose: onCloseCreateGameDialog })] }));
};
